module.exports = __webpack_public_path__ + "static/media/alensa.637f7b48.svg";